import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import Select from "components/common/Select";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { pollingInterval, contentTypes, compressionType } = formData;
  const availableContent = [
    { label: t("genericS3.content_types.json_array"), value: "JSON_ARRAY" },
    { label: t("genericS3.content_types.csv"), value: "COMMA_SEPARATED_VALUES" },
    { label: t("genericS3.content_types.gelf"), value: "GELF" },
    { label: t("genericS3.content_types.text_plain"), value: "TEXT_PLAIN" }
  ];
  const availableCompressionType = [
    { label: t("genericS3.compression_types.gzip"), value: "GZIP" },
    { label: t("genericS3.compression_types.none"), value: "NONE" }
  ];
  const [contentTypeVal] = useState(false);
  const [compressionTypeVal] = useState(false);
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: t("common.validation.polling_interval_invalid"),
        nice_message: t("genericS3.validation.polling_interval_min")
      });
    }
  };
  const handleSqsMessageBatchSizeChange = (errorMessage) => {
    if (errorMessage) {
      setFormError({
        full_message: errorMessage,
        nice_message: errorMessage
      });
    } else {
      setFormError(null);
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      disabled: !!formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("genericS3.subscribe.content_type")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        name: "content_type",
        id: "contentTypes",
        onChange: (selected) => onChange({ target: { name: "contentTypes", value: selected } }),
        options: availableContent,
        value: (contentTypes == null ? void 0 : contentTypes.value) || ""
      }
    ),
    contentTypeVal && (!(contentTypes == null ? void 0 : contentTypes.value) || contentTypes.value.length === 0) && /* @__PURE__ */ React.createElement("label", { htmlFor: "contentTypes" }, t("genericS3.fields.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("genericS3.subscribe.content_type_help")),
    /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "contents" }, t("genericS3.subscribe.compression_type")),
    /* @__PURE__ */ React.createElement(
      Select,
      {
        name: "compression_type",
        id: "compressionType",
        onChange: (selected) => onChange({ target: { name: "compressionType", value: selected } }),
        options: availableCompressionType,
        value: (compressionType == null ? void 0 : compressionType.value) || ""
      }
    ),
    compressionTypeVal && (!(compressionType == null ? void 0 : compressionType.value) || compressionType.value.length === 0) && /* @__PURE__ */ React.createElement("label", { htmlFor: "compressionType" }, t("genericS3.fields.select_at_least_one")),
    /* @__PURE__ */ React.createElement("span", { className: "help-block" }, t("genericS3.subscribe.compression_type_help")),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("genericS3.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange, handleSqsMessageBatchSizeChange })
  );
};
export default StepSubscribe;
